import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FormFeatureModule } from '@components/form/form.feature.module';

import {
    AccordionComponent,
    AccordionItemComponent,
    AlertComponent,
    ConfirmationModalComponent,
    DisplayLabelComponent,
    InfoModalComponent,
    InterventionModalComponent,
    ListboxComponent,
    LogoutModalComponent,
    ModalComponent,
    PageStepperComponent,
    PdfViewerComponent,
    PicklistComponent,
    ReportDownloadFormComponent,
    StepperComponent,
    TabsComponent,
    TextboxComponent,
    TreeComponent,
    WizardModalComponent,
    WizardStepComponent,
    WizardTitleComponent
} from './';
import { MaterialComponent } from "@components/material/material.component";
import { LanguagePickerComponent } from './language-picker/language-picker.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ToolPositionModalComponent } from "@components/tool-position-modal/tool-position-modal.component";
import { ToolTicketReportModalComponent } from './tool-ticket-report-modal/tool-ticket-report-modal.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { TabsNgComponent } from "@components/tabs-ng/tabs.component";
import { ScrollListComponent } from './scroll-list/scroll-list.component';
import { VirtualScrollerModule } from "ngx-virtual-scroller";
import { ScrollListItemComponent } from "@components/scroll-list/item/scroll-list-item.component";
import { ScrollListAddButtonComponent } from './scroll-list/scroll-list-add-button/scroll-list-add-button.component';
import { CircularButtonComponent } from './circular-button/circular-button.component';
import { ButtonComponent } from './button/button.component';
import { LabelComponent } from './label/label.component';
import { LinkComponent } from './link/link.component';

import { TimerComponent } from './timer/timer.component';
import { ControlButtonsComponent } from './control-buttons/control-buttons.component';
import { MaintenanceAccordionComponent } from '@app/maintenance/components/maintenance-accordion/maintenance-accordion.component';
import { GrouperListComponent } from '@app/maintenance/components/grouper-list/grouper-list.component';
import { LogicalGrouperComponent } from '@app/maintenance/components/logical-grouper/logical-grouper.component';
import { AssignationDropdownComponent } from '@app/maintenance/components/assignation-dropdown/assignation-dropdown.component';
import { TaskComponent } from '@app/maintenance/components/task/task.component';
import { TaskSelectionModalComponent } from '@app/maintenance/components/task-selection-modal/task-selection-modal.component';
import {
    MaintenancePlanOverviewComponent
} from '@app/maintenance/components/maintenance-plan-overview/maintenance-plan-overview.component';
import { ToolScanTreeComponent } from '@app/tool/components';
import {
    ActivitiesFormComponent
} from '@app/roles/admin/pages/ticket-management/components/ticket-create-modal/forms/activities-form/activities-form.component';
import { PhotoCarouselComponent } from './photo-carousel/photo-carousel.component';
import { TicketStatusComponent } from './ticket-status/ticket-status.component';
import { PhotoInputComponent } from './photo-input/photo-input.component';
import { ActivityComponent } from '@app/maintenance/components/activity/activity.component';
import { StrainMeasurementsListComponent } from "@components/strain-components/strain-measurements-list/strain-measurements-list.component";
import {
    StrainMeasurementResultCardComponent
} from "@components/strain-components/strain-measurement-result-card/strain-measurement-result-card.component";
import { OnHoldCardComponent } from '@app/roles/service-operator/pages/service-tickets/components/on-hold-card/on-hold-card.component';
import {
    TicketTaskDetailsComponent
} from '@app/roles/service-operator/pages/service-tickets/components/ticket-task-details/ticket-task-details.component';
import { RecurrenceComponent } from './recurrence/recurrence.component';
import { TicketDetailsComponent } from '@app/roles/service-operator/pages/service-tickets';
import { MessageComponent } from '@components/message/message.component';
import { PrimeNGLibraryModule } from "@components/_libraries/_primeng-library.module";
import { AngularMaterialLibraryModule } from "@components/_libraries/_angular-material-library.module";
import { NGXLibraryModule } from "@components/_libraries/_ngx-library.module";
import { IconButtonComponent } from './icon-button/icon-button.component';
import { FabComponent } from "@components/fab/fab.component";
import { InputSwitchModule } from "primeng/inputswitch";
import { RevisionInfoComponent } from './revision-info/revision-info.component';
import { RevisionInfoModalComponent } from './revision-info-modal/revision-info-modal.component';
import { TimeUnitPickerComponent } from './time-unit-picker/time-unit-picker.component';
import { BadgeScannerComponent } from './badge-scanner/badge-scanner.component';
import { ToolScannerComponent } from './tool-scanner/tool-scanner.component';
import { ToolProcessingCardComponent } from './tool-card/tool-processing-card.component';
import { ListboxItemComponent } from "@components/listbox/listbox-item.component";
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { FileCardComponent } from "@components/file-card/file-card.component";
import { StrainReportCardComponent } from "@components/strain-components/strain-report-card/strain-report-card.component";
import { RevisionMultiInfoComponent } from "@components/revision-multi-info/revision-multi-info.component";
import { DropDownButtonComponent } from "@app/shared/components/dropdown-button/dropdown-button.component";
import { EmptyStateComponent } from "@components/empty-state/empty-state.component";
import { VersatileListComponent } from "@components/versatile-list/versatile-list.component";
import { VersatileListItemDirective } from "@components/versatile-list/versatile-list-item.directive";
import { VersatileListHeaderComponent } from "@components/versatile-list/versatile-list-header.component";
import { VersatileListBodyComponent } from "@components/versatile-list/versatile-list-body.component";
import { VersatileListFooterComponent } from "@components/versatile-list/versatile-list-footer.component";
import { VersatileListBodyAfterDirective } from "@components/versatile-list/versatile-list-body-after.directive";
import { WizardInlineComponent } from './wizard-inline/wizard-inline.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        FormFeatureModule,
        PdfViewerModule,
        VirtualScrollerModule,
        PrimeNGLibraryModule,
        AngularMaterialLibraryModule,
        NGXLibraryModule,
        InputSwitchModule,

    ],
    declarations: [
        ModalComponent,
        AlertComponent,
        ConfirmationModalComponent,
        InfoModalComponent,
        LogoutModalComponent,
        PicklistComponent,
        TabsComponent,
        DisplayLabelComponent,
        ListboxComponent,
        TreeComponent,
        TextboxComponent,
        ReportDownloadFormComponent,
        AccordionComponent,
        AccordionItemComponent,
        PageStepperComponent,
        StepperComponent,
        InterventionModalComponent,
        WizardModalComponent,
        WizardTitleComponent,
        WizardStepComponent,
        MaterialComponent,
        LanguagePickerComponent,
        PdfViewerComponent,
        ToolPositionModalComponent,
        ToolTicketReportModalComponent,
        ContextMenuComponent,
        TabsNgComponent,
        ScrollListComponent,
        ScrollListItemComponent,
        ScrollListAddButtonComponent,
        CircularButtonComponent,
        ButtonComponent,
        LabelComponent,
        LinkComponent,
        TimerComponent,
        ControlButtonsComponent,
        MaintenancePlanOverviewComponent,
        MaintenanceAccordionComponent,
        GrouperListComponent,
        LogicalGrouperComponent,
        AssignationDropdownComponent,
        TaskComponent,
        TaskSelectionModalComponent,
        ToolScanTreeComponent,
        ActivitiesFormComponent,
        PhotoCarouselComponent,
        TicketStatusComponent,
        ActivityComponent,
        PhotoInputComponent,
        StrainMeasurementsListComponent,
        StrainMeasurementResultCardComponent,
        TicketTaskDetailsComponent,
        OnHoldCardComponent,
        TicketDetailsComponent,
        RecurrenceComponent,
        MessageComponent,
        IconButtonComponent,
        FabComponent,
        MessageComponent,
        RevisionInfoComponent,
        RevisionMultiInfoComponent,
        TimeUnitPickerComponent,
        BadgeScannerComponent,
        ToolScannerComponent,
        ToolProcessingCardComponent,
        ListboxItemComponent,
        BottomSheetComponent,
        LoadingSpinnerComponent,
        FileCardComponent,
        StrainReportCardComponent,
        RevisionInfoModalComponent,
        DropDownButtonComponent,
        VersatileListComponent,
        VersatileListItemDirective,
        VersatileListHeaderComponent,
        VersatileListBodyComponent,
        VersatileListBodyAfterDirective,
        VersatileListFooterComponent,
        EmptyStateComponent,
        WizardInlineComponent
    ],
    exports: [
        FormFeatureModule,
        TranslateModule,
        ModalComponent,
        AlertComponent,
        ConfirmationModalComponent,
        InfoModalComponent,
        LogoutModalComponent,
        PicklistComponent,
        TabsComponent,
        DisplayLabelComponent,
        ListboxComponent,
        TreeComponent,
        TextboxComponent,
        ReportDownloadFormComponent,
        AccordionComponent,
        AccordionItemComponent,
        PageStepperComponent,
        StepperComponent,
        InterventionModalComponent,
        WizardModalComponent,
        WizardTitleComponent,
        WizardStepComponent,
        MaterialComponent,
        LanguagePickerComponent,
        PdfViewerComponent,
        PdfViewerModule,
        ToolPositionModalComponent,
        ToolTicketReportModalComponent,
        ContextMenuComponent,
        TabsNgComponent,
        ScrollListComponent,
        ScrollListItemComponent,
        CircularButtonComponent,
        ButtonComponent,
        LabelComponent,
        LinkComponent,
        ContextMenuComponent,
        TimerComponent,
        ControlButtonsComponent,
        MaintenancePlanOverviewComponent,
        MaintenanceAccordionComponent,
        GrouperListComponent,
        LogicalGrouperComponent,
        AssignationDropdownComponent,
        TaskComponent,
        TaskSelectionModalComponent,
        ToolScanTreeComponent,
        ActivitiesFormComponent,
        PhotoCarouselComponent,
        TicketStatusComponent,
        ActivityComponent,
        PhotoInputComponent,
        StrainMeasurementsListComponent,
        StrainMeasurementResultCardComponent,
        TicketTaskDetailsComponent,
        RecurrenceComponent,
        OnHoldCardComponent,
        TicketDetailsComponent,
        MessageComponent,
        PrimeNGLibraryModule,
        AngularMaterialLibraryModule,
        NGXLibraryModule,
        IconButtonComponent,
        FabComponent,
        MessageComponent,
        RevisionInfoComponent,
        RevisionMultiInfoComponent,
        RevisionInfoModalComponent,
        TimeUnitPickerComponent,
        BadgeScannerComponent,
        ToolScannerComponent,
        ToolProcessingCardComponent,
        ListboxItemComponent,
        BottomSheetComponent,
        LoadingSpinnerComponent,
        FileCardComponent,
        StrainReportCardComponent,
        DropDownButtonComponent,
        VersatileListComponent,
        VersatileListItemDirective,
        VersatileListHeaderComponent,
        VersatileListBodyComponent,
        VersatileListBodyAfterDirective,
        VersatileListFooterComponent,
        EmptyStateComponent,
        WizardInlineComponent
    ]
})
export class ComponentsModule {
}
